export default "__VITE_ASSET__cd9fda5e__"